import { useSelector } from 'react-redux';

import { selectState } from '../../../../selectors';
import { GrayBackground } from '../../styled/thank-you';

import IossMiddleContent from './ioss';

const MiddleContent = () => {
  const {
    offer: {
      offerFlow,
      thankYouContent: { middleTextContent },
    },
  } = useSelector(selectState);

  switch (offerFlow) {
    case 'ioss':
      return <IossMiddleContent />;
    default: {
      if (!middleTextContent) return null;

      return (
        <GrayBackground className='flex justify-content-center'>
          <h3 className='text-center pad-all-lg' data-ref='offer.thank-you.middle-content.default'>
            {middleTextContent}
          </h3>
        </GrayBackground>
      );
    }
  }
};

export default MiddleContent;
